import { supabase } from "@/supabase";


export async function carregarDisciplinas() {
    const { data, error } = await supabase
        .from("disciplinas")
        .select("*")

    if (error) {
        console.log(error.message);
        return false;
    }

    return data;
}